export function resolveNativeWsProtocol({ protocol, webRtc, pageProtocol }) {
  const resolved = protocol || (pageProtocol === 'https:' || !webRtc ? 'wss' : 'ws')
  if (!['ws', 'wss'].includes(resolved)) {
    throw new Error('Invalid native WebSocket protocol')
  }
  if (pageProtocol === 'https:' && resolved !== 'wss') {
    throw new Error('HTTPS requires a secure native WebSocket endpoint')
  }
  return resolved
}

export function withNativeWsHost(connectToken, host) {
  if (!host) return connectToken
  if (!Array.isArray(connectToken?.resultInfo?.remoteList)
      || connectToken.resultInfo.remoteList.length === 0) {
    throw new Error('Missing native WebSocket endpoints')
  }
  // TLS changes only the WS host; ICE must retain the advertised UDP IP and port.
  return {
    ...connectToken,
    resultInfo: {
      ...connectToken.resultInfo,
      remoteList: connectToken.resultInfo.remoteList.map(endpoint => ({
        ...endpoint,
        remoteWsIp: host
      }))
    }
  }
}
